import { useMemo } from "react";

import { useAppSelector } from "@/redux/hooks";
import {
	webhookApi,
	useGetDeliveryWebhookQuery,
	useGetWebhookDeliveriesQuery,
	useGetWebhookDeliveryQuery,
	useGetWebhookRedeliveryCountsQuery,
} from "@/pages/Private/redux/webhook/webhook.api";

import type { DeliveryQuery, RedeliveryQuery } from "../schema/webhookDelivery";

/** Read the existing Redux API slice by its full argument, including warm-cache revisits. */
export function useDeliveryWebhook(id: number) {
	const request = useGetDeliveryWebhookQuery(id);
	const selector = useMemo(() => webhookApi.endpoints.getDeliveryWebhook.select(id), [id]);
	const { data } = useAppSelector(selector);

	return { ...request, data };
}
export function useDeliveryPage(query: DeliveryQuery, skip = false) {
	const request = useGetWebhookDeliveriesQuery(query, { skip, pollingInterval: 15000 });
	const selector = useMemo(() => webhookApi.endpoints.getWebhookDeliveries.select(query), [query]);
	const { data } = useAppSelector(selector);

	return { ...request, data };
}
export function useDeliveryDetail(webhookId: number, deliveryId: number) {
	const query = useMemo(() => ({ webhookId, deliveryId }), [webhookId, deliveryId]);
	const request = useGetWebhookDeliveryQuery(query, { pollingInterval: 15000 });
	const selector = useMemo(() => webhookApi.endpoints.getWebhookDelivery.select(query), [query]);
	const { data } = useAppSelector(selector);

	return { ...request, data };
}
export function useRedeliveryCounts(query: RedeliveryQuery, skip = false) {
	const request = useGetWebhookRedeliveryCountsQuery(query, {
		skip,
		refetchOnMountOrArgChange: true,
	});
	const selector = useMemo(
		() => webhookApi.endpoints.getWebhookRedeliveryCounts.select(query),
		[query]
	);
	const { data } = useAppSelector(selector);

	return { ...request, data };
}
